import {Button} from '@material-ui/core';
import {AddWith2ParamsOptions} from 'components/grid-dx/types';
import PopupRemove from 'components/Popups/PopupRemove';
import {i18n2} from 'features/i18n/i18n';
import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import {
  useGetProfiles,
  useIsActive,
  useSelectBetweenHooks,
} from '../hooks/index';
import {CLEAN, DISABLED_BUTTON} from '../types';

const Buttons = ({id, cancel, useSPAC}: any) => {
  const dispatch = useDispatch();
  // const dataSPAC = useProfileSPACInRedux();
  const data = useGetProfiles();
  const active: boolean = useIsActive();
  const promise = useSelectBetweenHooks(useSPAC);
  const [open, setOpen] = useState(false);
  const initial: any[] = [];

  const addWith2ParamsOptions: AddWith2ParamsOptions = {
    AddedOne: data,
    AddedTwo: id,
    AddedThree: initial,
  };

  const pressedAcepted = () => {
    setOpen(true);
    dispatch({type: DISABLED_BUTTON, payload: true});
  };

  const pressedCancel = () => {
    dispatch({type: CLEAN, payload: true});
    cancel();
  };

  return (
    <>
      {open && (
        <PopupRemove
          open={open}
          setOpen={setOpen}
          promiseToReturn={promise}
          types={addWith2ParamsOptions}
        />
      )}
      <Button
        variant="contained"
        className="cancel-contained"
        onClick={pressedCancel}>
        {i18n2._('Cancelar')}
      </Button>
      <Button
        disabled={active}
        variant="contained"
        color="primary"
        // style={{marginRight: '20px'}}
        onClick={pressedAcepted}>
        {i18n2._('Confirmar')}
      </Button>
    </>
  );
};

export default Buttons;
